import { useState } from 'react';

import { CheckCircledIcon, CopyIcon } from '@radix-ui/react-icons';
import { IconButton, Tooltip } from '@raystack/apsara';
import { Show } from '@studio/hoc';

interface CopyTextProps {
  text: string;
}

export const CopyText = ({ text }: CopyTextProps) => {
  const [success, setSuccess] = useState<boolean>(false);

  const copyTextToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 800);
    } catch {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        setSuccess(true);
        setTimeout(() => setSuccess(false), 800);
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }
  };

  return (
    <Show when={!success} fallback={<CheckCircledIcon />}>
      <Tooltip message='Copy text' side='top' contentStyle={{ zIndex: 10000 }}>
        <IconButton
          size={3}
          onClick={() => copyTextToClipboard(text)}
          data-test-id={`copy-icon-${text}`}
        >
          <CopyIcon />
        </IconButton>
      </Tooltip>
    </Show>
  );
};
